export const Share = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M20.791 12.607c.244-.209.366-.314.411-.438a.5.5 0 000-.338c-.045-.125-.167-.23-.41-.439l-8.471-7.26c-.42-.36-.63-.54-.809-.545a.5.5 0 00-.4.184C11 3.909 11 4.186 11 4.739v4.295a9.666 9.666 0 00-8 9.517v.612a11.4 11.4 0 018-4.093v4.19c0 .554 0 .83.112.969a.5.5 0 00.4.184c.178-.005.388-.185.809-.545l8.47-7.26z'
        ></path>
      </svg>
    </span>
  );
};
